import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Input, Form, message} from 'antd';
import {modal} from 'icsoc-antd-ex';
import enterpriseConfigActions from 'Actions/enterpriseConfig/enterpriseConfig';

const {ModalSize} = modal;
const FormItem = Form.Item;
const formItemLayout = {labelCol: {span: 5}, wrapperCol: {span: 19}};

class ConfigModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmLoading: false,
    };
  }

  // 点击确定
  handleSubmit = () => {
    const {
      configModalData: {vccId = ''} = {},
      form: {validateFields},
      getTableList,
      setConfigModalVisible,
      actions,
    } = this.props;

    validateFields((err, values) => {
      if (!err) {
        const {...rest} = values;
        const params = {
          ...rest,
        };

        this.setState({
          confirmLoading: true,
        });
        if (vccId) {
          actions
            .configCompanyInfo(params)
            .then(res => {
              const {payload: {code} = {}} = res || {};

              if (parseInt(code, 10) === 200) {
                setConfigModalVisible();
                message.success('操作成功！');
                getTableList();
              }
            })
            .finally(() => {
              this.setState({
                confirmLoading: false,
              });
            });
        } else {
          actions
            .addCompanyInfo(params)
            .then(res => {
              const {payload: {code} = {}} = res || {};

              if (parseInt(code, 10) === 200) {
                setConfigModalVisible();
                message.success('操作成功！');
                getTableList();
              }
            })
            .finally(() => {
              this.setState({
                confirmLoading: false,
              });
            });
        }
      }
    });
  };

  render() {
    const {
      configModalData: {
        vccId = '',
        projectNum = '',
        transferNumbers = '',
        callTimeOut = '',
        callbackUrl = '',
        appId = '',
        appSecret = '',
      } = {},
      form: {resetFields, getFieldDecorator},
      setConfigModalVisible,
    } = this.props;
    const {confirmLoading} = this.state;

    return (
      <ModalSize
        title={`${vccId ? '编辑' : '添加'}企业信息`}
        // zIndex="1002"
        centered
        maskClosable={false}
        visible
        onOk={this.handleSubmit}
        onCancel={setConfigModalVisible}
        confirmLoading={confirmLoading}
        afterClose={() => {
          resetFields();
        }}>
        <Form>
          <FormItem {...formItemLayout} label="企业ID">
            {getFieldDecorator('vccId', {
              initialValue: vccId,
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: '企业ID不得为空！',
                },
              ],
            })(
              <Input
                placeholder="请输入企业ID"
                maxLength="10"
                disabled={vccId}
              />,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="并发数">
            {getFieldDecorator('projectNum', {
              initialValue: projectNum,
              rules: [
                {
                  required: true,
                  pattern: new RegExp(/^[1-9]\d*$/, 'g'),
                  message: '并发数不得为空并且大于0！',
                },
              ],
              getValueFromEvent: event => {
                return event.target.value.replace(/\D/g, '');
              },
            })(<Input placeholder="请输入并发数" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="转人工号码">
            {getFieldDecorator('transferNumbers', {
              initialValue: transferNumbers,
            })(<Input placeholder="请输入转人工号码" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="最大振铃时长">
            {getFieldDecorator('callTimeOut', {
              initialValue: callTimeOut,
              rules: [
                {
                  required: true,
                  message: '最大振铃时长不得为空！',
                },
              ],
            })(<Input placeholder="请输入最大振铃时长" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="回调地址">
            {getFieldDecorator('callbackUrl', {
              initialValue: callbackUrl,
              rules: [
                {
                  whitespace: true,
                },
              ],
            })(<Input placeholder="请输入回调地址" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="AppId">
            {getFieldDecorator('appId', {
              initialValue: appId,
            })(<Input placeholder="请输入AppId" disabled="true" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="AppSecret">
            {getFieldDecorator('appSecret', {
              initialValue: appSecret,
            })(<Input placeholder="请输入AppSecret" disabled="true" />)}
          </FormItem>
        </Form>
      </ModalSize>
    );
  }
}
const mapStateToProps = ({enterpriseConfig}) => ({
  configModalData: enterpriseConfig.configModalData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(enterpriseConfigActions, dispatch),
});

const ConfigModalWrap = Form.create()(ConfigModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfigModalWrap);
